import React from 'react';

import cn from 'classnames';

import { isModalAttachment } from '@entities/attachment/lib/isModalAttachment';
import { isAttachmentResponse } from '@entities/task/lib/isAttachmentResponse';
import { IAttachmentResponse } from '@entities/task/model/types/tasks';
import { getNameExtension } from '@shared/helpers';
import { IModalAttachment } from 'entities/attachment/model/IModalAttachment.interface';

import cls from './AttachmentsList.module.css';
import { FileItem } from './FileItem';

interface IAttachmentsList {
    // attachments: IModalAttachment[];
    attachments: (IModalAttachment | IAttachmentResponse)[];
    isFileOver: boolean;
    handleOpenMenu: (fileId: string, position: { x: number; y: number }) => void;
    handleCloseMenu: () => void;
    containerRef: React.RefObject<HTMLDivElement>;
    handleFileItemClick: (e: React.SyntheticEvent, fileId: string) => void;
    activeMenuFileId: string;
    AddFileInput: React.ReactNode;
}

export const AttachmentsList = ({
    attachments,
    isFileOver,
    handleOpenMenu,
    handleCloseMenu,
    handleFileItemClick,
    containerRef,
    activeMenuFileId,
    AddFileInput,
}: IAttachmentsList) => (
    <ul className={cn(cls.AttachmentsList, { [cls.isFileOver]: isFileOver })}>
        {attachments.map((file) => {
            if (!isModalAttachment(file) && !isAttachmentResponse(file)) return null;

            const isFromClient = isModalAttachment(file);
            const fileName = isFromClient ? file.file.name : file.name;
            const { extension: fileExtension } = getNameExtension(fileName);

            return (
                <FileItem
                    key={file.id}
                    file={isFromClient ? file.file : undefined}
                    fileId={file.id}
                    fileName={fileName}
                    fileExtension={fileExtension}
                    isLoading={isFromClient ? file.isLoading : false}
                    imgUrl={isFromClient ? URL.createObjectURL(file.file) : file.preview_url}
                    isFromClient={isFromClient}
                    isImage={
                        isFromClient
                            ? file.file.type.startsWith('image/')
                            : file.mime_type.startsWith('image/')
                    }
                    onOpenMenu={handleOpenMenu}
                    onCloseMenu={handleCloseMenu}
                    onFileItemClick={handleFileItemClick}
                    containerRef={containerRef}
                    activeMenuFileId={activeMenuFileId}
                />
            );
        })}

        {AddFileInput}
    </ul>
);
